import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Error = createSvgIcon(
  <path d="M13.125 16.125a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Zm0-2.625V6.75h-2.25v6.75h2.25Z M.75.75v22.5h22.5V.75H.75ZM21 3v18H3V3h18Z" />,
  'Error'
);

export { Error };